exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container[data-v-f23cf326]{font-size:0.14rem\n}\n.container .iPopupBox[data-v-f23cf326]{width:100%;box-sizing:border-box;background-color:#F2F2F2;background-color:white;backface-visibility:hidden;-webkit-backface-visibility:hidden;position:fixed;left:0%;transition:0.2s ease-out\n}\n.container .shade[data-v-f23cf326]{position:fixed;left:0;right:0;top:0;bottom:0;width:100%;height:100%;background:#000;-moz-opacity:0.5;opacity:0.50;filter:alpha(opacity=70)\n}\n", ""]);

// exports
